<template>
    <div :class="readonly ? 'px-5' : ''" :style="{ 'backgroundImage': `url('${cover}')`}"
        class="hero position-relative py-5">
        <div class="hero__item--content container">
            <slot name="content" ></slot>
            <template v-if="Boolean(jobPostSetting)">
                <DetailsCard v-if="showHeader" :data="data" :content="content" :detailsStyle="detailsStyle"
                    :activePreview="activePreview" />
            </template>
        </div>
        <template v-if="showModal && pageSettingContent.length">
            <modal modal-id="about-us-modal" :title="itemToShow.headings" :modal-scroll="true" :hideFooter="true"
                modal-size="large" @closeModal="closeModal">
                <template slot="body">
                    <div class="p-2 p-md-3">
                        <div class="mb-2 d-flex justify-content-center"><img  :src="logo" alt="" class="icon"></div>
                        <div class="my-3" v-for="(item, index) in pageSettingContent" v-show="itemToShow.id === item.id">
                            <h5>{{ item.headings }}</h5>
                            <div v-html="item.description"></div>
                        </div>
                    </div>
                </template>
            </modal>
        </template>
    </div>
</template>

<script>

import { urlGenerator } from "../../../Helpers/AxiosHelper";
import HeroDropdown from "../../Views/CareerPage/HeroDropdown.vue";
import DetailsCard from "../../Views/Dashboard/DetailsCard";
import {v4} from "uuid";

export default {
    components: {
        HeroDropdown,
        DetailsCard
    },
    props: {
        icon: {
            type: String,
        },
        data: {
            type: Object,
        },
        showHeader: {
            type: Boolean,
            default: false
        },
        activePreview: {
            type: String,
            // required: true
        },
        logo: {
            type: String,
        },
        readonly: {
            type: Boolean,
        },
        cover: {
            type: String,
            default: ''
        },
        loggedIn: {
            type: Boolean,
            default: false
        },
        pageSettingContent: {
            type: Array,
            default: () => []
        },
        bodySection: {
            type: Array,
            default: () => []
        },
        careerPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            urlGenerator,
            searchText: '',
            showModal: false,
            itemToShow: ''
        }
    },
    methods: {
        search(event) {
            console.log(event)
        },
        editItem(item) {
            this.$emit('modal-trigger', item)
        },
        deleteItem(item) {
            this.$emit('item-delete', item)
        },
        init() {
            let content = document.querySelector('.hero__item--content')
            let cover = document.querySelector('.hero__item--cover')
            cover.style.height = content.clientHeight + 60
        },
        closeModal() {
            this.showModal = false
            this.itemToShow = '';
        },

        toggleModal(item) {
            this.itemToShow = item;
            this.showModal = true
        },
        handleAddNewSectionClick() {
            this.$emit('new-row-add');
        }
    },
    computed: {
        jobPostSetting() {
            if (!Boolean(this.data)) return null;
            if (typeof this.data['job_post_settings'] === 'string')
                return JSON.parse(this.data['job_post_settings']);
            return this.data['job_post_settings'];
        },
        content() {
            if (!this.jobPostSetting) return null;
            return this.jobPostSetting.content;
        },
        pageStyle() {
            if (!this.jobPostSetting) return null;
            return this.jobPostSetting.pageStyle;
        },
        pageView() {
            return this.activePreview === 'desktop' ? 'defaultView' : 'mobileView'
        },
        detailsStyle() {
            if (this.pageStyle) return this.pageStyle[this.pageView].find(item => item.key === 'details')
        },
    },
}
</script>

<style lang="scss" scoped>
.icon {
    max-width: 140px;
    width: 100%;
}

.search {
    display: flex;
    justify-content: center;
    align-items: center;

    input {
        border: 1px solid #fff;
        background-color: #ffffffdd;
        border-radius: 25px;
        max-width: 300px;
        width: 100%;
        padding: 5px 15px;
    }
}

.hero {
    //height: 300px;
    //height: 100%;
    padding-top: 9rem !important;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &__item {
        &--content {
            position: relative;
        }
    }
}

@media (max-width: 650px) {
    .hero {
        padding-top: 12rem !important;
    }
}

.about-us-btn a {
    text-decoration: none !important;
    color: var(--default-font-color);

    &:hover {
        color: #4466F2;
    }
}

.item-heading-wrapper {
    position: relative;


    &:hover {
        .cus-dropdown-wrapper {
            opacity: 1;
            pointer-events: auto;
        }
    }
} 

.cus-dropdown-wrapper {
    position: absolute;
    width: 10rem;
    opacity: 0;
    z-index: 2;
    pointer-events: none;
    border-radius: 0.25rem;

    li {
        padding: 1rem 0;
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }

    li:hover {
        background-color: #F0F2F5;
    }
}
</style>
